export function emailMatch(value: string) {
	return !!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
}